<template>
    <div class="border-b border-neutral-lightest py-lg">
        <div class="flex justify-between">
            <div>
                <p class="font-semibold mb-0">
                    {{ salesPeriod.name }}
                </p>
                <span class="text-xs">
                    {{ salesPeriodDates }}
                </span>
            </div>
            <div class="text-right">
                <button
                    type="button"
                    class="btn is-ghost btn-sm"
                    @click="showDetails = !showDetails"
                >
                    {{ showDetails ? 'Dölj' : 'Detaljer' }}
                </button>
            </div>
        </div>

        <div v-if="showDetails" class="py-lg">
            <slot />
        </div>
    </div>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        props: {
            salesPeriod: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                showDetails: false,
            };
        },
        computed: {
            salesPeriodDates() {
                const completedAt = this.salesPeriod.completed_at;
                const createdAt = this.salesPeriod.created_at;

                return `${format(createdAt, 'YYYY-MM-DD')} - ${format(completedAt, 'YYYY-MM-DD')}`;
            },
        },
    };
</script>
